import {Component, OnInit} from '@angular/core';
import {NotificationService} from "../../../../services/notificationService";
import _ from 'lodash';
import {DICTIONARY} from "../../../../dictionary";
import {RouteService} from "../../../../services/routeService";
import {AuthService} from "../../../../services/authService";
import {GeneralService} from "../../../../services/generalService";

@Component({
	selector: 'app-collaboration-protection-policies',
	templateUrl: './collaboration-protection-policies.component.html',
	styleUrls: ['./collaboration-protection-policies.component.scss'],
})
export class CollaborationProtectionPoliciesComponent implements OnInit {
	constructor(private ns: NotificationService,
				private rs:RouteService,
				public gs:GeneralService,
				private authService:AuthService) {}

	dic = DICTIONARY;

	config;
	configModels;
	isModelChanged;
	updatePolicyInProcess = false;
	getConfigInProcess;
	userInfo;

	ngOnInit() {
		this.getConfigInProcess = true;

		this.rs.getCollaborationConfiguration().then((response) => {
			this.config = response;
			this.configModels = _.cloneDeep(this.config.collaboration_protection);
			this.isModelChanged = false;
			this.getConfigInProcess = false;

		}, (err) => {
			this.getConfigInProcess = false;
		});

		this.gs.getUserInfo(false, userInfo => {
			this.userInfo = userInfo;
		});
	}


	toggleAction = (actions, value) => {
		if (value === this.dic.CONSTANTS.collaborationActions.quarantine && !this.isQuarantineSiteExists()) {
			this.gs.showPopup({
				title: `Enable Quarantine Storage`,
				subTitle: `To enable file quarantining, you must first permit the creation a dedicated SharePoint site. Click on "Create Site" below to continue.`,
				type: this.dic.CONSTANTS.popupInfo,
				doneBtnText: 'Create Site',
				doneCb: () => {
					this.createQuarantineSite();
				},
			});
			return;
		}

		const idx = actions.indexOf(value);
		if (idx === -1) {
			actions.push(value);
		} else if (idx !== -1) {
			actions.splice(idx, 1);
		}

		this.isModelChanged = !_.isEqual(this.configModels.policy.sensitivity_detected.actions.sort(), this.config.collaboration_protection.policy.sensitivity_detected.actions.sort()) ||
							  !_.isEqual(this.configModels.policy.malicious_detected.actions.sort(), this.config.collaboration_protection.policy.malicious_detected.actions.sort());
	}

	updatePolicySensitivityThreshold = () => {
		if (this.configModels.policy.sensitivity_threshold < 1 || this.configModels.policy.sensitivity_threshold > 5) {
			return;
		}

		const actionInfo = {
			action: 'sensitivity_threshold',
			sensitivity_threshold: this.configModels.policy.sensitivity_threshold
		};

		this.updatePolicyInProcess = true;

		this.rs.configureCollaborationPolicy(actionInfo).then(() => {
			this.updatePolicyInProcess = false;
			this.config.collaboration_protection.policy.sensitivity_threshold = this.configModels.policy.sensitivity_threshold;
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		}, () => {
			this.updatePolicyInProcess = false;
		});
	}

	updatePolicyProtectionMode = () => {
		const promises = [];
		let actionInfo = {};

		// changes done to "malicious_detected"
		if (!_.isEqual(this.configModels.policy.malicious_detected.actions.sort(), this.config.collaboration_protection.policy.malicious_detected.actions.sort())) {
			actionInfo = {
				action: 'malicious_detected',
				actions: this.configModels.policy.malicious_detected.actions,
			};
			promises.push(this.rs.configureCollaborationPolicy(actionInfo));
		}

		// changes done to "sensitivity_detected"
		if (!_.isEqual(this.configModels.policy.sensitivity_detected.actions.sort(), this.config.collaboration_protection.policy.sensitivity_detected.actions.sort())) {
			actionInfo = {
				action: 'sensitivity_detected',
				actions: this.configModels.policy.sensitivity_detected.actions,
			};
			promises.push(this.rs.configureCollaborationPolicy(actionInfo));
		}

		this.updatePolicyInProcess = true;

		Promise.all(promises)
			.then(results => {
				this.config.collaboration_protection.policy.sensitivity_detected.actions = _.clone(this.configModels.policy.sensitivity_detected.actions);
				this.config.collaboration_protection.policy.malicious_detected.actions = _.clone(this.configModels.policy.malicious_detected.actions);
				this.isModelChanged = false;

				this.updatePolicyInProcess = false;
				this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			})
			.catch(error => {
				this.updatePolicyInProcess = false;
			});
	}

	isQuarantineSiteExists() {
		return this.config.collaboration_protection?.microsoft?.quarantine_drive;
	}

	createQuarantineSite = () => {
		if (this.isQuarantineSiteExists() || this.updatePolicyInProcess) {
			return;
		}

		if (!this.config.collaboration_protection?.microsoft?.enabled || !this.config.collaboration_protection?.microsoft?.tid) {
			this.ns.showErrorMessage('Enable Collaboration Protection to use this feature.');
			return;
		}

		this.updatePolicyInProcess = true;
		const azEndpoint = this.config.azEndpoint || DICTIONARY.CONSTANTS.exchangeServerEndpoints.Global.AzureAD;
		this.authService.authForCollab(this.userInfo.email, this.config.collaboration_protection.microsoft.tid, azEndpoint, this.config.graphEndpoint, this.config.exchangeCollabUserAppId, (err) => {
			if (err) {
				if (err !== true) {
					err = err.replace('Sign in failed', 'Exchange API authentication failed');
					this.ns.showErrorMessage('Failed to run Collaboration Protection. ' + (err || 'Error'));
				}
				this.updatePolicyInProcess = false;
				return;
			}

			this.updatePolicyInProcess = false;
			this.config.collaboration_protection.microsoft.quarantine_drive = true;
			console.log('configureMicrosoftCollaboration done');
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			window.location.reload();
		});
	}
}
